import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { RenderTags } from '@vk-hr-tek/ui/input/MultipleAutocompleteInput';

import { MultipleAutocompleteInput } from '../../MultipleAutocompleteInput';

interface PositionsProps {
  name: string;
  hasPositions: boolean;
  loading: boolean;
  loadPositions: (filter: {
    limit: number;
    offset: number;
    query: string;
  }) => Promise<{ label: string; value: string }[]>;
  renderTags: RenderTags;
  onChange: (value?: string[]) => void;
}

export const PositionsInput = ({
  name,
  hasPositions,
  loading,
  loadPositions,
  renderTags,
  onChange,
}: PositionsProps) => (
  <Box display="flex" flexDirection="column">
    <Tooltip
      title="Нет должностей в списке"
      placement="right"
      disabled={hasPositions}
    >
      <Box>
        <MultipleAutocompleteInput
          type="load"
          disabled={!hasPositions}
          loading={loading}
          testId="test-id-positions-multiple-autocomplete-input"
          name={name}
          label="Должность"
          placeholder="Введите должность"
          loadItems={loadPositions}
          renderTags={renderTags}
          onChange={onChange}
        />
      </Box>
    </Tooltip>
  </Box>
);
